/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFuelCsvDataBody
 */
export interface CreateFuelCsvDataBody {
    /**
     * 
     * @type {number}
     * @memberof CreateFuelCsvDataBody
     */
    dateStart: number;
    /**
     * 
     * @type {number}
     * @memberof CreateFuelCsvDataBody
     */
    dateEnd: number;
}

/**
 * Check if a given object implements the CreateFuelCsvDataBody interface.
 */
export function instanceOfCreateFuelCsvDataBody(value: object): value is CreateFuelCsvDataBody {
    if (!('dateStart' in value) || value['dateStart'] === undefined) return false;
    if (!('dateEnd' in value) || value['dateEnd'] === undefined) return false;
    return true;
}

export function CreateFuelCsvDataBodyFromJSON(json: any): CreateFuelCsvDataBody {
    return CreateFuelCsvDataBodyFromJSONTyped(json, false);
}

export function CreateFuelCsvDataBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFuelCsvDataBody {
    if (json == null) {
        return json;
    }
    return {
        
        'dateStart': json['dateStart'],
        'dateEnd': json['dateEnd'],
    };
}

export function CreateFuelCsvDataBodyToJSON(json: any): CreateFuelCsvDataBody {
    return CreateFuelCsvDataBodyToJSONTyped(json, false);
}

export function CreateFuelCsvDataBodyToJSONTyped(value?: CreateFuelCsvDataBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateStart': value['dateStart'],
        'dateEnd': value['dateEnd'],
    };
}

